import { Indicator } from 'is24-corecss'
import styles from '../AttachmentsList.module.css'
import React from 'react'

export type TitleLabelProps = {
  title?: string
}

const TitleLabel: React.FC<TitleLabelProps> = ({ title }) => {
  return (
    title && (
      <div aria-label='typeLabel' className={`${styles.typeLabel} cursor-pointer absolute-content`}>
        <Indicator.Root appearance='label' color='white' variant='flat' className={`${styles.typeLabelIndicator}`}>
          <span data-testid={'title-label'}>{title}</span>
        </Indicator.Root>
      </div>
    )
  )
}

export default TitleLabel
